const ToastStr = {
    ERROR: '오류가 발생하였습니다.',
    TIME_OUT_STR: '요청 시간이 만료되었습니다.',
    NETWORK_UNREACHABLE_STR:
        '서버에 연결할 수 없습니다.\n네트워크를 연결해주세요.',

    //사용자 정보 관련
    LOGIN_FAIL: 'ID/PW가 올바르지 않습니다.',
    LOGIN_NO_AUTHORITY: '운영자 권한이 없습니다.',
    LOGIN_ZERO_LENGTH: '아이디와 비밀번호를 모두 입력해 주세요.',
    EMAIL_CHECK_STR: '정확한 이메일계정과 주소를 입력해주세요.',
    EMAIL_ADDR_CHECK_LEN: '아이디는 32자 이내입니다.',
    EMAIL_ADDR_CHECK_STR: '아이디를 입력해 주세요.',
    EMAIL_AUTH_CHECK_STR: '아이디 인증을 해주시기 바랍니다.',
    PWD_ET_CHECK_STR: '비밀번호는 6~20자를 입력해주세요.',
    PWD_CHECK_FALSE_STR: '비밀번호가 일치하지 않습니다.',
    NAME_ET_CHECK_STR: '정확한 이름을 입력해주세요.',
    PHONE_ET_CHECK_STR: '핸드폰번호 11자를 입력해주세요.',
    GENDER_SELECT_CHECK_STR: '성별을 선택해주세요.',
    EMAIL_DUPLICATION: '아이디가 중복입니다. 다른 아이디를 입력해주세요.',
    EMAIL_EXCEPTION: '해당 아이디가 존재하지 않습니다.',
    EMAIL_SEND_SUCCESS_STR: '인증 메일이 발송되었습니다.',
    EMAIL_SEND_FAIL_STR:
        '인증 메일이 발송되지 않았습니다.\n다시 시도해 주세요.',
    EMAIL_AUTH_SUCCESS_STR: '사용 가능한 이메일입니다.',
    JOIN_SUCCESS_STR: '회원가입이 완료되었습니다.',
    JOIN_FAIL_STR: '회원가입에 실패했습니다.\n다시 시도해 주세요.',
    AUTH_ID_SUCCSESS_STR: '아이디 검색에 성공했습니다.',
    AUTH_ID_FAIL_STR: '찾으시는 아이디가 없습니다.',
    PW_FIND_SUCCESS: '임시 비밀번호가 메일로 전송되었습니다.',
    PW_FIND_FAIL: '임시 비밀번호 변경에 실패했습니다.\n다시 시도해 주세요.',
    PW_CHANGE_SUCCESS: '비밀번호가 변경되었습니다.',
    PW_CHANGE_FAIL: '비밀번호 변경에 실패했습니다.\n다시 시도해 주세요.',
    LOGIN_FAIL_STR: '입력한 이메일 또는 비밀번호의 정보가 없습니다.',
    LOGOUT_SUCCESS_STR: '로그아웃 되었습니다.',
    CLASS_ING_LOGOUT_FAIL_STR: '교육 진행중에 로그아웃을 할 수 없습니다.',
    CLASS_WAIT_LOGOUT_FAIL_STR: '교육 대기중에 로그아웃을 할 수 없습니다.',
    LOGOUT_FAIL_STR: '로그아웃을 할 수 없습니다.',
    DELETE_ACCOUNT_MESSAGE_FAIL_STR: '입력한 내용을 다시 한 번 확인해주세요.',
    DELETE_ACCOUNT_FAIL_STR: '입력한 내용을 다시 한 번 확인해주세요.',
    ID_APPROVE_FAIL_STR: '관리자의 승인이 필요합니다.',
    OPER_CHECKED_STR: '하나 이상의 관리자를 선택해주세요.',
    OPER_APPROVE_SUCCESS_STR: '선택하신 관리자를 모두 승인했습니다.',
    OPER_APPROVE_FAIL_STR: '관리자 승인에 실패했습니다.',
    OPER_DELETE_SUCCESS_STR: '선택하신 관리자를 모두 삭제했습니다.',
    OPER_DELETE_FAIL_STR: '관리자 삭제에 실패했습니다.',

    ID_CHECK_STR: '정확한 ID를 입력해주세요.',
    ID_DUPLICATION: 'ID가 중복입니다. 다른 ID를 입력해주세요.',
    ID_ADDR_CHECK_LEN: 'ID는 32자 이내입니다.',
    ID_ADDR_CHECK_STR: 'ID를 입력해 주세요.',
    ID_AUTH_CHECK_STR: 'ID 인증을 해주시기 바랍니다.',
    ID_AUTH_SUCCESS_STR: '사용 가능한 ID입니다.',

    //클래스 관련
    CLASS_CODE_CHECK_STR: '클래스 코드를 입력해 주세요.',
    CLASS_ENTER_SUCCESS: '클래스에 입장하였습니다.',
    CLASS_ENTER_FAIL: '정확한 클래스 코드를 입력해 주세요.',
    CLASS_EXIT_FAIL_STR: '클래스를 변경할 수 없습니다.',
    CLASS_ING_EXIT_FAIL_STR: '교육 진행중에 클래스를 변경할 수 없습니다.',
    CLASS_FINISH_EXIT_FAIL_STR:
        '교육이 종료되어 클래스를 변경할 수 없습니다.\n클래스를 변경하기 위해서 로그아웃을 해주세요.',
    CLASS_CEO_EXIT_FAIL_STR:
        "모든 직원이 나가야 'CEO'는 클래스를 변경할 수 있습니다.",
    CLASS_CREATE_FAIL_STR: '클래스 생성에 실패했습니다.',
    CLASS_CREATE_SUCCESS_STR: '클래스 생성에 성공했습니다.',
    CLASS_CODE_DUPLICATION:
        '클래스 코드가 중복입니다. 다른 클래스 코드를 입력해주세요.',
    CLASS_AUTH_SUCCESS_STR: '사용 가능한 클래스 코드입니다.',
    CLASS_ADDR_CHECK_STR: '클래스 코드를 입력해 주세요.',
    CHECK_VALIDATE_CODE_STR: '코드의 중복 확인을 해주십시오.',
    CHECK_MONEY_INFO_STR: '자금 정보에는 숫자를 입력해주십시오.',
    CLASS_TYPE_NUM_STR: '클래스의 제조기업, 유통기업 수를 입력해주십시오.',
    CLASS_END_TIME_STR: '클래스의 종료 시각을 입력해주십시오.',
    CLASS_NO_START_STR:
        '클래스가 아직 시작하지 않았습니다. 교육시작을 먼저 해주십시오.',
    CLASS_FINISH_STR:
        '클래스가 종료되었습니다. 교육중인 클래스를 선택 해주십시오.',
    CLASS_COUNTRY_STR: '검색하려는 지역을 입력하여 주십시오.',
    CLASS_CHECKED_STR: '하나 이상의 클래스를 선택해 주십시오.',
    CLASS_END_SUCCESS_STR: '선택하신 클래스 코드를 모두 종료했습니다.',
    CLASS_END_FAIL_STR: '클래스 코드 종료에 실패했습니다.',
    CLASS_START_SUCCESS_STR: '선택하신 클래스 코드를 모두 시작했습니다.',
    CLASS_START_FAIL_STR: '클래스 시작에 실패했습니다.',
    CLASS_NOT_STARTED_STR: '클래스가 아직 시작하지 않았습니다.',
    CLASS_ALREADY_END_STR: '이미 종료된 클래스입니다.',

    //기업 관련
    COMPANY_NAME_CHECK_STR: '기업 이름을 입력해 주세요.',
    COMPANY_EXIST_STR: '이미 설립된 새싹기업 이름입니다.',

    COMPANY_FOUNDATION_SUCCESS: '새싹기업이 설립되었습니다.',
    COMPANY_FOUNDATION_RELOGIN: '로그인을 다시해 주세요.',
    COMPANY_FOUNDATION_FAIL: '새싹기업 설립을 할 수 없습니다.',
    COMPANY_LIST_FAIL_STR: '기업 목록을 가져올 수 없습니다.',
    COMPANY_LIST_EMPTY_STR: '기업 목록이 없습니다.',
    COMPANY_APP_FAIL_STR: '입사지원에 실패했습니다.',
    COMPANY_APP_DELETE_FAIL_STR: '이미 신청이 승인 되었습니다!',
    COMPANY_APP_DUPLICATE_STR: '이미 지원한 기업입니다.',
    COMPANY_APP_SUCCESS_STR:
        '입사지원이 완료되었습니다.\n입사승인이 완료될 때까지 기다려 주세요.',
    COMPANY_APP_INFO_FAIL_STR: '입사승인이 완료되지 않았습니다.',
    COMPANY_APP_DEL_SUCCESS_STR: '입사지원 취소가 완료되었습니다.',
    COMPANY_APP_DEL_FAIL_STR: '입사지원 취소에 실패했습니다.',
    COMPANY_ENTER_FAIL_STR: '입사신청 정보를 가져올 수 없습니다.',
    COMPANY_INFO_FAIL_STR: '기업 정보를 가져올 수 없습니다.',
    COMPANY_APP_LIST_FAIL_STR: '지원자 목록을 가져올 수 없습니다.',
    COMPANY_APP_LIST_EMPTY_STR: '지원자가 없습니다.',
    COMPANY_APPROVAL_SUCCESS_STR: '입사승인이 완료되었습니다.',
    COMPANY_APPROVAL_FAIL_STR: '입사승인에 실패했습니다.',
    COMPANY_DECLINE_SUCCESS_STR: '입사거절이 완료되었습니다.',
    COMPANY_DECLINE_FAIL_STR: '입사거절에 실패했습니다.',
    COMPANY_STOCK_INSUFFICIENT_STR: '기업에 자금이 부족합니다.',
    COMPANY_MEMBER_UPDATE_SUCCESS_STR: '팀원 정보 수정이 완료되었습니다.',
    COMPANY_DELETE_SUCCESS_STR: '기업 삭제가 완료되었습니다.',
    COMPANY_DELETE_FAIL_STR: '기업 삭제가 실패했습니다.',
    COMPANY_ASSET_UPDATE_STR: '기업 자금을 수정했습니다.',

    //대출 관련
    LOAN_LIST_FAIL_STR: '대출 목록을 가져올 수 없습니다.',
    LOAN_SUCCESS_STR: '대출이 완료되었습니다.',
    LOAN_FAIL_STR: '대출에 실패했습니다.',
    LOAN_PAYBACK_SUCCESS_STR: '대출 상환이 완료되었습니다.',
    LOAN_PAYBACK_FAIL_STR: '대출 상환에 실패했습니다\n다시 시도해주세요.',
    LOAN_CLASS_NO_START_STR:
        '교육이 시작하지 않아 대출금 상환 및 대출을 할 수 없습니다.',
    LOAN_CLASS_FINISH_STR:
        '교육이 종료되어 대출금 상환 및 대출을 할 수 없습니다.',
    LOAN_INSUFFICIENT_STR: '대출금 상환에 필요한 자금이 부족합니다.',
    LOAN_OVER_LOAN_STR:
        '누적 대출금이 최대 대출 금액을 넘어 더 이상 대출이 불가능합니다.',
    LOAN_PAYBACK_UPDATE_EXCEPTION_STR: '업데이트에서 오류가 발생하였습니다.',
    LOAN_PRICE_INVALID_STR: '대출 금액을 입력해주세요.',

    //재료 관련
    MATERIAL_LIST_FAIL_STR: '재료 목록을 가져올 수 없습니다.',
    MATERIAL_LIST_EMPTY_STR: '재료 목록이 없습니다.',
    MATERIAL_EMPTY_STR: '재료 정보를 불러올 수 없습니다.',
    MATERIAL_ORDER_SUCCESS_STR: '재료 주문이 완료되었습니다.',
    MATERIAL_ORDER_FAIL_STR: '재료 주문을 할 수 없습니다.',
    MATERIAL_ORDER_LIST_FAIL_STR: '재료 주문 목록을 가져올 수 없습니다.',
    MATERIAL_ORDER_LIST_EMPTY_STR: '주문한 재료 목록이 없습니다.',
    MATERIAL_SALES_LIST_FAIL_STR: '재료 주문 목록을 가져올 수 없습니다.',
    MATERIAL_SALES_LIST_EMPTY_STR: '주문받은 재료 목록이 없습니다.',
    MATERIAL_ORDER_CANCEL_SUCCESS_STR: '원재료 주문이 취소되었습니다.',
    MATERIAL_ORDER_CANCEL_FAIL_STR: '원재료 주문 취소에 실패했습니다.',
    MATERIAL_PURCHASE_LIST_FAIL_STR: '구매한 재료 목록을 가져올 수 없습니다.',
    MATERIAL_PURCHASE_LIST_EMPTY_STR: '구매한 재료 목록이 없습니다.',
    MATERIAL_AUTH_SUCCESS_STR: '사용 가능한 재료 코드입니다.',
    MATERIAL_CODE_CHECK_STR: '재료 코드를 입력해 주세요.',
    MATERIAL_CODE_DUPLICATION:
        '재료 코드가 중복입니다. 다른 재료 코드를 입력해주세요.',
    MATERIAL_CREATE_SUCCESS_STR: '재료 생성에 성공했습니다.',
    MATERIAL_CREATE_FAIL_STR: '재료 생성에 실패했습니다.',
    MATERIAL_APPROVAL_SUCCESS_STR: '재료판매에 성공하셨습니다.',
    MATERIAL_APPROVAL_FAIL_STR: '재료판매에 실패했습니다.',
    MATERIAL_DECLINE_SUCCESS_STR: '재료판매를 거절하셨습니다.',
    MATERIAL_DECLINE_FAIL_STR: '재료판매 거절을 실패하셨습니다.',
    MATERIAL_SALE_FINISH: '이미 팔린 재료입니다.',
    MATERIAL_LOAN_LEFT: '아직 상환하지 않은 재료가 있습니다',
    MATERIAL_LOAN_APPROVAL_STR: '이자 상환에 성공하셨습니다.',
    MATERIAL_LOAN_FAIL_STR: '이자 상환에 실패했습니다.',
    MATERIAL_PAYBACK_APPROVAL_STR: '재료 상환에 성공하셨습니다.',
    MATERIAL_PAYBACK_FAIL_STR: '재료 상환에 실패했습니다.',
    MATERIAL_STOCK_INSUFFICIENT_STR: '재료가 부족합니다.',
    MATERIAL_SHEET_DUPLICATE_STR: '다른 사용자가 주문서를 처리 중 입니다.',

    //라이센스 관련
    LICENSE_LIST_FAIL_STR: '라이센스 목록을 가져올 수 없습니다.',
    LICENSE_LIST_EMPTY_STR: '라이센스 목록이 없습니다.',
    LICENSE_EMPTY_STR: '라이센스 정보를 불러올 수 없습니다.',
    LICENSE_RND_SUCCESS_STR: '라이센스 연구개발이 완료되었습니다.',
    LICENSE_RND_FAIL_STR: '라이센스 연구개발을 할 수 없습니다.',
    LICENSE_RND_DUPLICATE_STR: '현재 기업에서 개발 중인 상태입니다.',
    LICENSE_RND_CANT_STR: '연구개발이 불가능합니다.',
    LICENSE_RND_CANCEL_FAIL_STR: '연구개발을 취소할 수 없습니다.',

    LICENSE_AUTH_SUCCESS_STR: '사용 가능한 라이센스 코드입니다.',
    LICENSE_NAME_CHECK_STR: '라이센스 이름을 입력해 주세요.',
    LICENSE_NAME_DUPLICATION:
        '라이센스 이름이 중복입니다. 다른 라이센스 이름을 입력해주세요.',
    LICENSE_CREATE_SUCCESS_STR: '라이센스 생성에 성공했습니다.',
    LICENSE_CREATE_FAIL_STR: '라이센스 생성에 실패했습니다.',

    //제품 생산 관련
    PRODUCTION_LIST_FAIL_STR: '생산 가능한 제품 목록이 없습니다.',
    PRODUCTION_EMPTY_STR: '제품 생산 정보를 불러올 수 없습니다.',
    //라이센스 메뉴얼 관련
    LICENSE_INFO_EMPTY_STR: '라이센스 상세정보를 볼 수 없습니다.',
    LICENSE_MATERIAL_LIST_FAIL_STR:
        '라이센스의 재료 목록을 가져올 수 없습니다.',
    LICENSE_MATERIAL_LIST_EMPTY_STR: '라이센스의 재료 정보가 없습니다.',
    LICENSE_MENUAL_PDF_FILE_EMPTY_STR: '메뉴얼 정보가 없습니다.',
    PRODUCT_LIST_FAIL_STR: '개발이 완료된 완제품 목록을 가져올 수 없습니다.',
    PRODUCT_EMPTY_STR: '완제품 정보를 불러올 수 없습니다.',
    PRODUCT_SALE_APP_SUCCESS: '제품판매 요청이 완료되었습니다.',
    PRODUCT_SALE_UPDATE_SUCCESS: '제품 가격이 수정되었습니다.',
    PRODUCT_SALE_APP_FAIL: '제품판매 요청에 실패했습니다.',
    PRODUCT_SALE_APP_INSUFFICIENT_FAIL:
        '재료가 부족해 판매 신청을 할 수 없습니다.',
    PRODUCT_SALE_APP_CHECK_INSUFFICIENT_FAIL:
        '재료가 부족해서 판매할 수 없어요.',
    PRODUCT_SALE_APP_CHECK_SUFFICIENT_SUCCESS:
        '재료가 다 있어요. 제품을 만든 후 판매해 주세요.',
    PRODUCT_SALE_APP_CANCEL_SUCCESS: '제품판매 요청이 취소되었습니다',
    PRODUCT_SALE_APP_FINISH_FAIL: '다른 팀원이 제품을 판매했습니다.',
    PRODUCT_SALE_FINISH: '이미 팔린 제품입니다.',

    PRODUCT_SALE_LIST_FAIL_STR: '판매된 완제품 목록을 가져올 수 없습니다.',
    PRODUCT_SALE_LIST_EMPTY_STR: '판매된 완제품 목록이 없습니다.',
    PRODUCT_PURCHASE_EMPTY_STR: '구매한 제품이 없습니다.',
    PRODUCT_SALE_COMPANY_UPDATE_STR:
        '제품 판매 대상이 다른 회사로 변경됐습니다.',

    //운영진
    //재료 구매 요청 관련
    MATERIAL_APP_LIST_FAIL_STR: '재료 구매 요청 목록을 가져올 수 없습니다.',
    MATERIAL_APP_LIST_EMPTY_STR: '재료 구매 요청 목록이 없습니다.',
    MATERIAL_SHEET_LIST_FAIL_STR: '재료 구매 주문서 목록을 가져올 수 없습니다.',
    MATERIAL_SHEET_LIST_DUPLICATE_STR: '다른 운영자가 주문서를 처리 중 입니다.',
    MATERIAL_SHEET_LIST_EMPTY_STR: '재료 구매 주문서 목록이 없습니다.',
    MATERIAL_SALE_SUCCESS: '원재료 판매가 완료되었습니다.',
    MATERIAL_SALE_FAIL: '원재료 판매에 실패했습니다.',
    MATERIAL_SALE_LIST_FAIL_STR: '판매된 재료 목록을 가져올 수 없습니다.',
    MATERIAL_SALE_LIST_EMPTY_STR: '판매된 재료 목록이 없습니다.',
    MATERIAL_LOAN_LIST_EMPTY_STR: '판매한 재료가 없습니다.',

    //제품 판매 요청 관련
    PRODUCT_APP_LIST_FAIL_STR: '제품 판매 가능 목록을 가져올 수 없습니다.',
    PRODUCT_APP_LIST_EMPTY_STR: '제품 판매 가능 목록이 없습니다.',
    PRODUCT_PURCHASE_SUCCESS: '완제품 구매가 완료되었습니다.',
    PRODUCT_DELETE_SUCCESS: '선택한 완제품이 삭제되었습니다',
    PRODUCT_PURCHASE_FAIL: '완제품 구매에 실패했습니다.',
    PRODUCT_DELETE_FAIL: '선택한 제품이 삭제되지 않았습니다.',
    PRODUCT_PURCHASE_LIST_FAIL_STR: '구매한 제품 목록을 가져올 수 없습니다.',
    PRODUCT_PURCHASE_LIST_EMPTY_STR: '구매한 제품 목록이 없습니다.',
    PRODUCT_LIST_NULL: '구매한 제품이 없습니다.',
    PRODUCT_DECOMPOSE_PROCEEDING_STR: '제품의 분해 신청이 진행중입니다.',
    PRODUCT_DECOMPOSE_SUCCESS_STR: '제품 분해 신청이 완료되었습니다.',
    PRODUCT_DECOMPOSE_FAIL_STR: '제품 분해 신청이 실패했습니다.',
    PRODUCT_DECOMPOSE_SUCCESS: '제품 분해가 완료되었습니다.',
    PRODUCT_DECOMPOSE_FAIL: '제품 분해가 실패했습니다.',
    PRODUCT_DECOMPOSE_EMPTY_STR: '제품 분해 신청이 없습니다.',
    PRODUCT_PRICE_WRONG_STR: '제품의 가격이 적정 범위에서 벗어났습니다.',

    REQUEST_GET_POST_FAIL_STR: '요청에 실패했습니다.\n다시 시도해 주세요.',
};

export default ToastStr;
